export function SpellCardShowcase() {
  return (
    <div className="grid place-items-center [perspective:1400px]">
      <div
        className="relative flex aspect-[4/5.4] w-full max-w-[400px] flex-col overflow-hidden rounded-[14px]
                   border border-gold-400/40 bg-[linear-gradient(160deg,#221a12,#140c08)]
                   shadow-[0_40px_80px_rgba(0,0,0,0.6),inset_0_0_0_1px_rgba(201,165,92,0.15),0_0_80px_rgba(123,215,255,0.08)]
                   animate-card-float [transform-style:preserve-3d]"
      >
        <span
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 140% 80% at 50% 0%, rgba(163,39,39,0.25), transparent 65%),' +
              'radial-gradient(ellipse 100% 60% at 50% 100%, rgba(109,76,255,0.15), transparent 70%)',
          }}
        />
        <div className="relative z-[2] flex h-full flex-col p-7 [transform:translateZ(40px)] [transform-style:preserve-3d]">
          <div className="flex items-start justify-between">
            <div className="rounded-sm border border-blood-500/40 bg-blood-500/10 px-2.5 py-1 font-display
                            text-[11px] uppercase tracking-[0.28em] text-blood-500">
              Creo · Ignem
            </div>
            <div className="text-right">
              <div className="font-display text-[34px] font-bold leading-none text-gold-300">20</div>
              <div className="mt-1 font-display text-[9px] font-medium tracking-[0.35em] text-gold-500">
                LEVEL
              </div>
            </div>
          </div>

          <div className="mx-auto my-4 h-[130px] w-[130px] [transform:translateZ(30px)]">
            <svg viewBox="-60 -60 120 120" className="overflow-visible">
              <g stroke="#7bd7ff" fill="none" strokeWidth="1" className="animate-rune-pulse">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 0 0"
                  to="360 0 0"
                  dur="24s"
                  repeatCount="indefinite"
                />
                <circle r="54" opacity="0.5" />
                <circle r="48" opacity="0.9" />
                <g>
                  <line x1="0" y1="-54" x2="0" y2="-48" />
                  <line x1="0" y1="54" x2="0" y2="48" />
                  <line x1="-54" y1="0" x2="-48" y2="0" />
                  <line x1="54" y1="0" x2="48" y2="0" />
                </g>
              </g>
              <g stroke="#c9a55c" fill="none" strokeWidth="1.1" className="animate-rune-pulse">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="360 0 0"
                  to="0 0 0"
                  dur="18s"
                  repeatCount="indefinite"
                />
                <circle r="38" opacity="0.6" />
                <g fontFamily="Cinzel, serif" fontSize="8" fill="#c9a55c" stroke="none" textAnchor="middle">
                  <text x="0" y="-30">CR</text>
                  <text x="26" y="-14">IG</text>
                  <text x="26" y="18">AN</text>
                  <text x="0" y="34">FO</text>
                  <text x="-26" y="18">ME</text>
                  <text x="-26" y="-14">VI</text>
                </g>
              </g>
              <g stroke="#a32727" fill="none" strokeWidth="1.2">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 0 0"
                  to="360 0 0"
                  dur="10s"
                  repeatCount="indefinite"
                />
                <path d="M 0 -24 L 22.8 7.4 L -14.1 -19.4 L 14.1 -19.4 L -22.8 7.4 Z" opacity="0.85" />
                <circle r="24" opacity="0.5" />
              </g>
              <circle r="4" fill="#ffd98a" />
              <circle r="9" fill="none" stroke="#ffd98a" strokeWidth="0.6" opacity="0.5" />
            </svg>
          </div>

          <h3 className="text-center font-serif text-[28px] font-normal leading-tight text-parchment-50">
            Pilum of <em className="italic text-gold-300">Fire</em>
          </h3>
          <div
            className="mx-auto my-3 h-px w-1/2"
            style={{ background: 'linear-gradient(to right, transparent, #a0782c, transparent)' }}
          />
          <div className="grid grid-cols-3 gap-2 text-center">
            {[
              { l: 'Range', v: 'Voice' },
              { l: 'Duration', v: 'Momentary' },
              { l: 'Target', v: 'Individual' },
            ].map((m) => (
              <div key={m.l}>
                <div className="text-[9px] uppercase tracking-[0.25em] text-gold-500">{m.l}</div>
                <div className="mt-0.5 font-serif text-sm text-parchment-100">{m.v}</div>
              </div>
            ))}
          </div>
          <div className="mt-5 font-serif italic text-[13.5px] leading-[1.55] text-parchment-100/75">
            "A javelin of white-hot flame flies from the magus's hand, striking with the fury of a forged lance."
          </div>
          <div
            className="mt-auto flex justify-between border-t border-gold-400/20 pt-4 font-display
                       text-[10px] uppercase tracking-[0.25em] text-gold-500"
          >
            <span>Spell · R-20</span>
            <span>Open License</span>
          </div>
        </div>
      </div>
    </div>
  );
}
